import React from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";

import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

const TutorialViewer: React.FC = () => {
  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: (defaultTabs) => [defaultTabs[0]],

    setInitialTab: async () => 0,
  });

  return (
    <>
      <style>{`

        /* =================================
           Sidebar Background Handling
        ================================= */

        /* Default sidebar closed state */
        .rpv-default-layout__sidebar {
            background-color: transparent !important;
        }

        /* Sidebar opened state */
        .rpv-default-layout__container:has(.rpv-default-layout__sidebar--opened)
        .rpv-default-layout__sidebar {
            background-color: #e3f2fd !important;
        }

        /* =================================
           Thumbnail Button Styling
        ================================= */

        /* Normal thumbnail button */
        button[aria-label="Thumbnail"] {
            background-color: transparent !important;
            color: inherit !important;
            border-radius: 4px;
        }


        /* Thumbnail hover */
        button[aria-label="Thumbnail"]:hover {
            background-color: #e3f2fd !important;
        }


        /* Selected thumbnail */
        button[aria-label="Thumbnail"].rpv-core__minimal-button--selected {
            background-color: #1976d2 !important;
            color: white !important;
            border-radius: 4px;
        }


        /* Selected thumbnail hover */
        button[aria-label="Thumbnail"].rpv-core__minimal-button--selected:hover {
            background-color: #1565c0 !important;
        }


        /* Selected thumbnail icon */
        button[aria-label="Thumbnail"].rpv-core__minimal-button--selected svg {
            fill: white !important;
            stroke: white !important;
        }

        /* =================================
           Hide Search
        ================================= */

        [data-testid="search__popover-button"],
        [data-testid="search__button"],
        button[aria-label="Search"] {
            display: none !important;
        }

        /* =================================
           Hide More Actions
        ================================= */

        [data-testid="toolbar__more-actions-button"],
        button[aria-label="More actions"],
        button[title="More actions"] {
            display: none !important;
        }

        /* =================================
           Hide Bookmarks / Attachments
        ================================= */

        [data-testid="bookmark__tab"],
        [data-testid="attachment__tab"] {
            display: none !important;
        }

        /* =================================
           Hide Open File
        ================================= */

        [data-testid="open__button"],
        [data-testid="open__menu"] {
            display: none !important;
        }

        /* =================================
           Hide Print
        ================================= */

        [data-testid="print__button"],
        [data-testid="print__menu"] {
            display: none !important;
        }

        /* =================================
           Hide Download
        ================================= */

        [data-testid="get-file__button"],
        [data-testid="get-file__menu"],
        [data-testid="download__button"],
        [data-testid="download__menu"],
        button[aria-label="Download"],
        button[title="Download"] {
            display: none !important;
        }

      `}</style>

      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          flexDirection: "column",
          margin: 0,
          padding: 0,
          overflow: "hidden",
        }}
      >
        {/* <div
          style={{
            height: "50px",
            display: "flex",
            alignItems: "center",
            paddingLeft: "16px",
            fontSize: "18px",
            fontWeight: "600",
            backgroundColor: "#1976d2",
            color: "white",
          }}
        >
          J-Gate Tutorial
        </div> */}
        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
          <Viewer
            fileUrl="https://diskoverapi.jgatenext.com/api/jgate_tutorial/"
            plugins={[defaultLayoutPluginInstance]}
            defaultScale={0.9}
          />
        </Worker>
      </div>
    </>
  );
};

export default TutorialViewer;
